const DATES_AVAILABILITY = {
  title: 'Gestor de Pedidos',
  greetings: {
    title: 'Olá,',
    subtitle:
      'Aqui você pode selecionar as datas em que a sua loja não está disponível para a venda de Chopp',
  },
  datesAvailability: {
    title:
      'Selecione as datas que você deseja que sua loja não esteja disponível para venda no app do Zé Delivery',
    subtitle: 'Seleção de Datas Indisponíveis',
    legend: {
      fullDay: 'Dia inteiro Bloqueado',
      morning: 'Manhã Bloqueada',
      afternoon: 'Tarde Bloqueada',
    },
    deliveryTypeTabs: {
      scheduled: 'Agendada',
      pickup: 'Retirada',
    },
    clearButtonLabel: 'Limpar Datas Indisponiveis',
    saveButtonLabel: 'Salvar',
  },
  buttons: {
    clearDates: 'Limpar Datas Indisponíveis',
    saveDates: 'Salvar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Salvar',
  },
  modals: {
    confirmDates: {
      title: 'Porque você vai bloquear essa janela de entrega?',
      subtitle: 'Descreva o motivo com o máximo de detalhes.',
    },
    clearDates: {
      title: 'Tem certeza que deseja resetar as datas bloqueadas?',
      subtitle: 'Essa ação não poderá ser desfeita.',
    },
    availabilityModal: {
      modalTitle: 'Período de indisponibilidade para SKU',
      calendarTitle: 'Selecione o período de indisponibilidade',
      calendarInstructions: 'É possível selecionar apenas um período por vez.',
      reasonLabel: 'Motivo',
      reasonPlaceholder: 'Descreva o motivo',
      skuPriceLabel: 'Preço de venda no Zé Delivery',
      clearDatesTitle: 'Remover datas indisponíveis',
      clearDatesDescription:
        'Tem certeza que deseja remover as datas de indisponibilidade? Essa ação não poderá ser desfeita.',

      confirmDatesTitle: 'Confirmar datas indisponíveis',
      confirmDatesDescription:
        'Porque você vai bloquear essa janela de entrega? Descreva o motivo com o máximo de detalhes.',
    },
  },
  toastMessages: {
    success: 'Janela de bloqueio atualizada',
    error: 'Ops! Ocorreu um erro ao atualizar janela',
  },
  drawerAvailabilityControl: {
    title: 'Editar disponibilidade',
    currentStatusLabel: 'Status atual:',
    currentStatusByDate: {
      available: 'Dia Inteiro Livre',
      morning: 'Manhã bloqueada',
      afternoon: 'Tarde bloqueada',
      'full-day': 'Dia Inteiro Bloqueado',
    },
    subtitle: 'Alterar para',
    morning: 'Bloquear manhã (10h - 14h)',
    afternoon: 'Bloquear tarde (14h - 18h)',
    fullDay: 'Bloquear dia inteiro (10h - 18h)',
    selectedMorning: 'Liberar manhã (10h - 14h)',
    selectedAfternoon: 'Liberar tarde (14h - 18h)',
    selectedFullDay: 'Liberar dia inteiro (10h - 18h)',
    descriptionLabel:
      'Descreva com o máximo de detalhes o motivo do bloqueio dessa janela de entrega',
  },
}

export default DATES_AVAILABILITY
